const SubAbasPdps = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/secsaude/produtosdaf/pdps/ficha/${id}/dadosgerais`,
  },
];

export default SubAbasPdps;
